module.exports = __webpack_public_path__ + "img/volume-high.348698fb.svg";